export class TranslationScope {
  /**
   * The parent translation scope for instance FOO
   */
  public parent: string;
  /**
   * The full translation scope for current process step for instance FOO.BAR
   */
  public current: string;

  /**
   * The shared translation scope that should contain common translations. e.g. FOO.COMMON
   */
  public shared: string;

  public constructor(parent: string, current: string) {
    this.parent = parent;
    this.shared = `${parent}.COMMON`;
    this.current = current;
  }

  public toString(): string {
    return this.current;
  }
}
